import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-form-field-description',
  templateUrl: './form-field-description.component.html',
  styleUrls: ['./form-field-description.component.scss'],
})
export class FormFieldDescriptionComponent {}
